
<template>
  <v-layout wrap justify-center px-3 px-md-0>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-flex xs12 md10 lg9>
      <!-- <v-container  style="background-color:green" > -->
      <v-layout wrap>
        <v-flex xs12 sm6 py-5>
          <v-layout wrap>
            <!-- <v-flex xs12 pb-4>
             Home > Orders
            </v-flex> -->
            <v-flex xs12 style="font: 20px robotomedium">My Orders </v-flex>
            <!-- <v-flex xs12 class="RB medium2" style="color: #d39c00"
              >Out for Delivery</v-flex
            > -->
            <v-flex xs12 class="RR clr medium2"
              >Estimated arrival on Fri, 2 Jul</v-flex
            >
            <v-flex xs12 py-4>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs12>
              <v-card flat v-for="(item, i) in order" :key="i">
                <v-layout wrap py-lg-3>
                  <v-flex xs2 v-if="item.productId.photos[0].length <1">
                    <v-img src="../../assets/images/f1.png"> </v-img>
                  </v-flex>
                   <v-flex xs2 v-else>
                    <v-img :src="mediaURL + item.productId.photos[0]"> </v-img>
                  </v-flex>
                  <v-flex xs8 pl-3>
                    <div style="font-family: robotobold">{{item.name}}</div>
                    <div class="RR clr medium2">QTY:{{item.quantity}}</div>
                    <div class="RR clr medium2">
                      <span style="color:#d39c00">{{item.productOrderStatus}} </span>
                    </div>
                  </v-flex>
                  <v-flex style="font-family: robotobold" text-right>
                    Rs.{{item.price}}
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card tile flat color="#F4F4F4">
                <v-layout wrap>
                  <v-flex xs6 py-3>
                    <span style="margin-left: 10px" class="RR">3 items</span>
                  </v-flex>
                  <v-flex xs6 text-right py-3>
                    <span style="margin-right: 10px" class="RR"
                      >Total: {{total}} INR</span
                    >
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex xs12 pt-3>
              <v-card tile flat color="#F4F4F4">
                <v-layout wrap>
                  <v-flex xs6 py-3>
                    <span style="margin-left: 10px" class="RR clr"
                      >Payment Method</span
                    >
                  </v-flex>
                  <v-flex xs6 text-right py-3>
                    <span style="margin-right: 10px" class="RR"
                      >Cash on Delivery</span
                    >
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm6 lg5 pl-sm-5 pt-md-0 pl-lg-11>
          <v-layout wrap>
            <v-flex xs12>
              <v-card color="#F4F4F4" tile flat>
                <v-layout wrap justify-center>
                  <v-flex xs12 pt-5 pl-lg-5 pt-lg-10 px-3 py-3>
                    <span class="RB clr medium">My Older Orders</span>
                  </v-flex>
                  <v-flex pl-5 xs12 v-if="myorder.length < 1">
                    <span class="RB">No ORders....!</span>
                  </v-flex>
                  <v-flex xs12 v-else>
                    <v-card
                      flat
                      v-for="(item, i) in myorder"
                      :key="i"
                      color="#F4F4F4"
                      tile
                    >
                      <v-layout wrap py-lg-3 px-3 px-lg-5>
                        <v-flex xs2 v-if="item.productId.photos[0].length < 1">
                          <v-img src="../../assets/images/f2.png"> </v-img>
                        </v-flex>
                        <v-flex xs2>
                          <v-img :src="mediaURL + item.productId.photos[0]">
                          </v-img>
                        </v-flex>

                        <v-flex xs6 md8 pl-3>
                          <div style="font-family: robotobold">
                            {{ item.name }}
                          </div>
                          <div
                            style="
                              font-family: robotoregular;
                              font-size: 12px;
                              color: grey;
                            "
                          >
                            <span>QTY:{{ item.quantity }}</span>
                          </div>
                          <div class="RR">{{ item.productOrderStatus }}</div>
                        </v-flex>
                        <v-flex style="font-family: robotobold" text-right>
                          <div>RS.{{ item.price }}</div>
                          <br />
                          <router-link
                            style="text-decoration: none"
                            :to="
                              'myOrderView?orderid=' +
                              item.order_id +
                              '&product=' +
                              item._id
                            "
                          >
                            <div><v-icon>mdi-chevron-right</v-icon></div>
                          </router-link>
                        </v-flex>
                        <v-flex xs6 py-5>
                          <span class="RR clr">
                            Rate this Product
                          </span></v-flex
                        >
                        <v-flex xs6 py-5 text-right>
                          <v-rating
                            small
                            :value="rating"
                            @click="addRating()"
                            color="yellow"
                            background-color="yellow"
                          >
                          </v-rating>
                        </v-flex>
                        <v-flex xs12>
                          <v-divider></v-divider>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 py-4>
                    <v-pagination
                      color="yellow"
                      circle
                      v-model="currentPage"
                      :length="pages"
                    >
                    </v-pagination>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <!-- </v-container> -->
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading:false,
      myorder: [],
      currentPage:1,
      pages: 0,
      count: 4,
      rating: 0,
      total:null,
      order:[],
      
    };
  },
  watch: {  
    currentPage() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "post",
        url: "/my/orders/products/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          count: this.count,
          page: this.currentPage,
        },
      }).then((response) => {
        if (response.data.status) {
          this.myorder = response.data.data;
          this.pages = response.data.pages;
          this.total = response.data.total;
          this.order = response.data.orders;
        }
        this.appLoading = false;
      });
    },
  },
};
</script>